import Home from "views/Home";
import Page from "views/Page";
import Post from "views/Post";
import HotelPage from "./views/Accommodation/HotelPage";
import SingleActivityPage from "./views/Activities/SingleActivityPage/SingleActivityPage";
import CheckoutPage from "./views/CheckoutPage/CheckoutPage";
import AccommodationPage from "./views/Accommodation/AccommodationPage";
import ActivitiesPage from "./views/Activities/ActivitiesPage";
import DiningPage from "./views/Dining/DiningPage";
import RestaurantPage from "./views/Dining/RestaurantPage";
import SingleEventPage from "./views/Events/SingleEventPage";
import FailedCheckout from "./views/FailedCheckout";
import RentalPage from "./views/Rental/RentalPage";
import RentalProductPage from "./views/Rental/RentalProductPage";
import ConferencePage from "./views/Conference/ConferencePage";
import ConferenceVenuePage from "./views/Conference/ConferenceVenuePage";
import FavoritesPage from "./views/FavoritesPage";

import NotFound from "views/NotFound";
import SummaryPage from "views/SummaryPage/SummaryPage";
import { RedirectToBookVisit } from "views/Accommodation/RedirectToBookVisit";

export default [
  {
    path: "/cms",
    exact: true,
    component: () => window.location.replace("/cms/wp-login.php"),
  },

  { path: "/404", exact: true, component: NotFound },

  //Custom language support
  { path: "/en/404", exact: true, component: NotFound },

  // home page
  { path: "/", exact: true, component: Home },

  //Custom language support
  { path: "/en/accommodation", exact: true, component: () => <RedirectToBookVisit lang="en" type="accommodation" /> },
  {
    path: "/en/accommodation/:slug",
    exact: true,
    component: () => <RedirectToBookVisit lang="en" type="accommodation" />,
  },
  { path: "/en/adventures", exact: true, component: ActivitiesPage },
  { path: "/en/adventures/:slug", exact: true, component: SingleActivityPage },
  { path: "/en/food-and-drinks", exact: true, component: DiningPage },
  { path: "/en/food-and-drinks/:slug", exact: true, component: RestaurantPage },
  { path: "/en/eventcalendar/:slug", exact: true, component: SingleEventPage },
  { path: "/en/rental", exact: true, component: RentalPage },
  { path: "/en/rental/:slug", exact: true, component: RentalProductPage },
  { path: "/en/conferences", exact: true, component: () => <RedirectToBookVisit lang="en" type="conference" /> },
  { path: "/en/conference", exact: true, component: () => <RedirectToBookVisit lang="en" type="conference" /> },
  {
    path: "/en/conferences/:slug",
    exact: true,
    component: ConferenceVenuePage,
  },
  { path: "/en/checkout", exact: true, component: CheckoutPage },
  { path: "/en/checkout/success", exact: true, component: SummaryPage },
  { path: "/en/favorites", exact: true, component: FavoritesPage },
  { path: "/en/:grandparent/:parent/:slug", exact: true, component: Page },

  // posts (news)
  { path: "/nyheter/:slug", exact: true, component: Post },

  // custom routes with special views
  { path: "/overnatting", exact: true, component: () => <RedirectToBookVisit lang="no" type="accommodation" /> },
  { path: "/overnatting/:slug", exact: true, component: () => <RedirectToBookVisit lang="no" type="accommodation" /> },
  { path: "/opplevelser", exact: true, component: ActivitiesPage },
  { path: "/opplevelser/:slug", exact: true, component: SingleActivityPage },
  { path: "/mat-og-drikke", exact: true, component: DiningPage },
  { path: "/mat-og-drikke/:slug", exact: true, component: RestaurantPage },
  { path: "/eventkalender/:slug", exact: true, component: SingleEventPage },
  { path: "/utleie", exact: true, component: RentalPage },
  { path: "/utleie/:slug", exact: true, component: RentalProductPage },
  { path: "/konferanser", exact: true, component: () => <RedirectToBookVisit lang="no" type="conference" /> },
  { path: "/konferanser/:slug", exact: true, component: () => <RedirectToBookVisit lang="no" type="conference" /> },
  { path: "/checkout", exact: true, component: CheckoutPage },
  { path: "/checkout/success", exact: true, component: SummaryPage },
  { path: "/checkout/failed", exact: true, component: FailedCheckout },
  { path: "/favoritter", exact: true, component: FavoritesPage },

  // pages
  { path: "/:slug", exact: true, component: Page },
  { path: "/:parent/:slug", exact: true, component: Page },
  { path: "/:grandparent/:parent/:slug", exact: true, component: Page },

  { path: "/en/*", exact: false, component: NotFound },
  { path: "/*", exact: false, component: NotFound },
];
